import type { Option } from '../Content'
import type { State } from './State'

type GetBIAnswerParams = {
  options: Option[]
  value: State['value']
}

const overrides: Record<string, string> = {
  preferred: 'prechecked',
  regular: 'popular',
}

export const getBIAnswer = (params: GetBIAnswerParams) => {
  const { options, value } = params
  return options.reduce((acc: Record<string, string>, option) => {
    const level = overrides[option.level] || option.level
    acc[option.biSlug] = `${!!value[option.optionKey]} (${level})`
    return acc
  }, {})
}
